import { Button } from '@material-ui/core'
import { orange } from '@material-ui/core/colors'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'

export class OperacionesFumigadoSiloDialogView extends Component {
  render () {
    const {
      silo,
      openDialogModificacionFumigado,
      openDialogNuevoFumigado,
      openDialogEliminarUltimoFumigado
    } = this.props
    const opcionesVacio = []
    // opcionesVacio.push(
    //   <Col md={12} className='center'>
    //     <Button style={{ color: green[500] }} onClick={() => openDialogInicioLlenado(silo)}>
    //       INICIO LLENADO
    //     </Button>
    //   </Col>
    // )
    // if (silo.fechaDeVaciado != null) {
    //   opcionesVacio.push(
    //     <Col md={12} className='center'>
    //       <Button style={{ color: red[500] }} onClick={() => openDialogEliminarUltimoVaciado(silo)}>
    //         ELIMINAR ULTIMO VACIADO
    //       </Button>
    //     </Col>
    //   )
    // }
    const opcionesEnUso = []
    // opcionesEnUso.push(
    //   <>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: green[500] }} onClick={() => openDialogModificacionLlenado(silo)}>
    //         MODIFICAR LLENADO
    //       </Button>
    //     </Col>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: green[500] }} onClick={() => openDialogFinLlenado(silo)}>
    //         FINALIZAR LLENADO
    //       </Button>
    //     </Col>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: blue[500] }} onClick={() => openDialogCubicaje(silo)}>
    //           CUBICAJE
    //       </Button>
    //     </Col>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: red[500] }} onClick={() => openDialogEliminarInicioLlenado(silo)}>
    //         ELIMINAR INICIO DE LLENADO
    //       </Button>
    //     </Col>
    //   </>
    // )
    const opcionesLleno = []
    // opcionesLleno.push(
    //   <>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: green[500] }} onClick={() => openDialogModificacionLlenado(silo)}>
    //         MODIFICAR LLENADO
    //       </Button>
    //     </Col>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: green[500] }} onClick={() => openDialogVaciado(silo)}>
    //         VACIAR SILO
    //       </Button>
    //     </Col>
    //     <Col md={12} className='center'>
    //       <Button style={{ color: red[500] }} onClick={() => openDialogEliminarFinLlenado(silo)}>
    //         ELIMINAR FIN DE LLENADO
    //       </Button>
    //     </Col>
    //   </>
    // )
    const opcionesInhabilitado = []
    // opcionesInhabilitado.push(
    //   <Col md={12} className='center'>
    //     <Button style={{ color: green[500] }} onClick={() => openDialogHabilitacion(silo)}>
    //       HABILITAR SILO
    //     </Button>
    //   </Col>
    // )
    const opcionesFumigable = []
    opcionesFumigable.push(
      <Col md={12} className='center'>
        <Button style={{ color: orange[500] }} onClick={() => openDialogNuevoFumigado(silo)}>
        NUEVO FUMIGADO
        </Button>
      </Col>
    )
    if (silo.fechaUltimoFumigado) {
      opcionesFumigable.push(
        <>
          <Col md={12} className='center'>
            <Button style={{ color: orange[500] }} onClick={() => openDialogEliminarUltimoFumigado(silo)}>
          ELIMINAR ULTIMO FUMIGADO
            </Button>
          </Col>
          <Col md={12} className='center'>
            <Button style={{ color: orange[500] }} onClick={() => openDialogModificacionFumigado(silo)}>
          MODIFICAR ULTIMO FUMIGADO
            </Button>
          </Col>
        </>
      )
    }

    return (
      <div>
        <Row>
          <Col md={12}>
            <h4>Operaciones disponibles ({silo.nombreCorto}): </h4>
          </Col>
        </Row>
        <Row>
          {(silo.estado === 'V' || silo.estado === null) && opcionesVacio}
          {silo.estado === 'U' && opcionesEnUso}
          {silo.estado === 'L' && opcionesLleno}
          {silo.estado === 'D' && opcionesInhabilitado}
          {(silo.estado === 'U' || silo.estado === 'L') && opcionesFumigable}
        </Row>
      </div>
    )
  }
}
